import {
  BaseQueryFn,
  EndpointBuilder,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { ResponseList, Supervisor } from "types";
import apiRoutes from "../apiRoutes";

export const supervisiorApi = (
  builder: EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
    string,
    "api"
  >
) => ({
  getSupervisor: builder.query<
    ResponseList<Supervisor>,
    { hierarchy?: string }
  >({
    query: ({ hierarchy }) => ({
      url: apiRoutes.getSupervisor(hierarchy ? `?hierarchy=${hierarchy}` : ""),
      method: "GET",
    }),
  }),
});
